var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Tier"},[_c('div',{staticClass:"icon is-round",class:[`is-${_vm.size}`, {'has-background-primary': _vm.displayTier === 'A', 'has-background-dark': _vm.displayTier === 'B' }]},[(_vm.displayTier)?[_vm._v(" "+_vm._s(_vm.displayTier)+" ")]:_vm._e(),_c('div')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }